var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, CardBody, CardFooter, Container, Form, FormGroup, Input, Label } from 'reactstrap';
import { ApplicationContext } from '../../../ApplicationContext';
import { FormErrorContext } from '../../../FormErrorContext';
import Signals from '../../../signals/Signals';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import UpdateDeviceSettingsCommand from '../../../commands/devices/UpdateDeviceSettingsCommand';
import Switch from '../../components/ui/Switch/Switch';
import DeviceGpsSetting from '../../../data/DeviceGpsSetting';
import FormField from '../../components/ui/FormField/FormField';
import UpdateDeviceNameCommand from '../../../commands/devices/UpdateDeviceNameCommand';
import BasicFormGroup from '../../components/ui/BasicFormGroup/BasicFormGroup';
import Session from '../../../services/Session';
import { calculateIntervalStringAndType, calculateRawIntervalValue, getAllowedValue, isAllowedInterval, WakeupIntervalType, wakeUpIntervalTypeText } from "../../../utils/wakeupIntervalUtils";
import SquareWarningMessage from "../../components/ui/SquareWarningMessage/SquareWarningMessage";
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var UpdateDeviceSettingsOverlay = /** @class */ (function (_super) {
    __extends(UpdateDeviceSettingsOverlay, _super);
    function UpdateDeviceSettingsOverlay(props) {
        var _this = _super.call(this, props) || this;
        var session = Session;
        _this.state = {
            errors: [],
            submitting: false,
            deviceModel: _this.props.deviceModel,
            gpsEnabled: _this.props.initialGpsSettingValue != DeviceGpsSetting.Disabled,
            newOperatingHoursEnabledValue: _this.props.initialOperatingHoursEnabled,
            newGpsSettingValue: (_this.props.initialGpsSettingValue == DeviceGpsSetting.Disabled ? DeviceGpsSetting.Medium : _this.props.initialGpsSettingValue),
            newWakeupIntervalValue: 0,
            wakeupIntervalType: WakeupIntervalType.DAY,
            wakeupAllowedValue: true,
            wakeupIntervalInput: "0",
            newDeviceName: _this.props.deviceModel.name,
            onDeviceUpdate: _this.props.onDeviceUpdate,
            // For now enable alls users to edit the device settings
            settingsDisabled: false
        };
        _this.onCancel = _this.onCancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        return _this;
    }
    UpdateDeviceSettingsOverlay.prototype.componentDidMount = function () {
        this.setInitInterval();
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    UpdateDeviceSettingsOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    UpdateDeviceSettingsOverlay.prototype.setInitInterval = function () {
        if (typeof this.props.initialWakeupIntervalSecondsValue !== "undefined") {
            if (typeof this.props.initialWakeupIntervalSecondsValue !== "undefined") {
                var intervalAndType = calculateIntervalStringAndType(this.props.initialWakeupIntervalSecondsValue);
                this.setState({
                    newWakeupIntervalValue: this.props.initialWakeupIntervalSecondsValue,
                    wakeupIntervalInput: intervalAndType.intervalString,
                    wakeupIntervalType: intervalAndType.intervalType
                });
            }
        }
    };
    UpdateDeviceSettingsOverlay.prototype.setInterval = function (interval, intervalType) {
        if (!interval) {
            interval = "";
            this.setState({ wakeupAllowedValue: false });
        }
        var convertedInterval = calculateRawIntervalValue(interval, intervalType);
        if (convertedInterval !== null && !isNaN(convertedInterval)) {
            if (!isAllowedInterval(convertedInterval)) {
                var allowedValue = getAllowedValue(convertedInterval);
                // do not overwrite UI elements as user might still be typing
                this.setState({ newWakeupIntervalValue: allowedValue, wakeupAllowedValue: false });
            }
            else {
                this.setState({ newWakeupIntervalValue: convertedInterval, wakeupAllowedValue: true });
            }
        }
        this.setState({ wakeupIntervalInput: interval, wakeupIntervalType: intervalType });
    };
    /**
     *
     */
    UpdateDeviceSettingsOverlay.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, intl = _a.intl;
        var _b = this.state, errors = _b.errors, deviceModel = _b.deviceModel, wakeupIntervalType = _b.wakeupIntervalType, newWakeupIntervalValue = _b.newWakeupIntervalValue, wakeupAllowedValue = _b.wakeupAllowedValue, wakeupIntervalInput = _b.wakeupIntervalInput, newOperatingHoursEnabledValue = _b.newOperatingHoursEnabledValue, newGpsSettingValue = _b.newGpsSettingValue, gpsEnabled = _b.gpsEnabled, newDeviceName = _b.newDeviceName, settingsDisabled = _b.settingsDisabled;
        return React.createElement(Container, { className: 'update-device-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'device.settings.update.overlay.title' }, deviceModel) }),
                        React.createElement(CardBody, null,
                            React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'device.settings.update.overlay.field.name' }), htmlFor: "newDeviceName" },
                                React.createElement(Input, { type: "text", id: "newDeviceName", name: "newDeviceName", value: newDeviceName || '', onChange: function (e) { return _this.setState({ newDeviceName: e.target.value }); } })),
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, null,
                                    React.createElement(Label, { for: "newWakeupIntervalSecondsValue", className: 'w-100' },
                                        React.createElement(FormattedMessage, { id: "device.settings.wakeupinterval" })),
                                    React.createElement(Input, { type: "number", id: "newWakeupIntervalValue", name: "newWakeupIntervalValue", required: true, disabled: settingsDisabled, className: 'w-50', placeholder: intl.formatMessage({ id: 'device.settings.wakeupinterval' }), value: wakeupIntervalInput || '', onBlur: function () {
                                            _this.setInterval(wakeupIntervalInput, wakeupIntervalType);
                                            var _a = calculateIntervalStringAndType(newWakeupIntervalValue), intervalString = _a.intervalString, intervalType = _a.intervalType;
                                            _this.setState({ wakeupIntervalInput: intervalString, wakeupIntervalType: intervalType });
                                        }, onChange: function (e) { return _this.setInterval(e.target.value, wakeupIntervalType); } }),
                                    React.createElement("select", { disabled: settingsDisabled, className: "form-control w-50", id: "wakeupIntervalType", name: "wakeupIntervalType", value: wakeupIntervalType, onChange: function (e) {
                                            // Using enums, so we can parse it to an int and cast it to the enum to get the corresponding value
                                            _this.setInterval(wakeupIntervalInput, parseInt(e.target.value));
                                        }, required: true },
                                        React.createElement("option", { value: WakeupIntervalType.MINUTE }, wakeUpIntervalTypeText(WakeupIntervalType.MINUTE, intl)),
                                        React.createElement("option", { value: WakeupIntervalType.HOUR }, wakeUpIntervalTypeText(WakeupIntervalType.HOUR, intl)),
                                        React.createElement("option", { value: WakeupIntervalType.DAY }, wakeUpIntervalTypeText(WakeupIntervalType.DAY, intl))))),
                            !wakeupAllowedValue && (React.createElement(SquareWarningMessage, { message: intl.formatMessage({ id: 'device.settings.notAllowedValue' }, {
                                    min: '4 minuten',
                                    max: '7 dagen' //TODO translate & make the distinction between the interval abbrevations & fully written
                                }) })),
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, null,
                                    React.createElement(Switch, { disabled: settingsDisabled, id: "newOperationHoursEnabledValue", checked: newOperatingHoursEnabledValue, onChange: function () {
                                            _this.setState({ newOperatingHoursEnabledValue: !newOperatingHoursEnabledValue });
                                        } },
                                        React.createElement(FormattedMessage, { id: "device.settings.operatinghours" })))),
                            React.createElement(FormGroup, null,
                                React.createElement(Switch, { disabled: settingsDisabled, id: "gpsEnabled", checked: gpsEnabled, onChange: function () {
                                        _this.setState({ gpsEnabled: !gpsEnabled });
                                    } },
                                    React.createElement(FormattedMessage, { id: "device.settings.gps.enable" })),
                                this.state.gpsEnabled && !settingsDisabled &&
                                    React.createElement(FormField, null,
                                        React.createElement(Label, { for: "newGpsSettingValue", className: 'mt-3' },
                                            React.createElement(FormattedMessage, { id: "device.settings.gps.accuracy" })),
                                        React.createElement("select", { className: "form-control", id: "newGpsSettingValue", name: "newGpsSettingValue", value: newGpsSettingValue, onChange: function (e) {
                                                _this.setState({ newGpsSettingValue: e.target.value });
                                            }, required: true },
                                            React.createElement("option", { value: DeviceGpsSetting.Low }, intl.formatMessage({ id: 'device.settings.gps.accuracy.low' })),
                                            React.createElement("option", { value: DeviceGpsSetting.Medium }, intl.formatMessage({ id: 'device.settings.gps.accuracy.medium' })),
                                            React.createElement("option", { value: DeviceGpsSetting.High }, intl.formatMessage({ id: 'device.settings.gps.accuracy.high' }))),
                                        React.createElement(Label, { className: 'text-muted' },
                                            React.createElement(FormattedMessage, { id: "device.settings.gps.batterylife" }))))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.labels.save" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     * @param event
     */
    UpdateDeviceSettingsOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var intl = this.props.intl;
        var _a = this.state, deviceModel = _a.deviceModel, newOperatingHoursEnabledValue = _a.newOperatingHoursEnabledValue, newGpsSettingValue = _a.newGpsSettingValue, newWakeupIntervalValue = _a.newWakeupIntervalValue, gpsEnabled = _a.gpsEnabled, wakeupIntervalType = _a.wakeupIntervalType, newDeviceName = _a.newDeviceName, settingsDisabled = _a.settingsDisabled;
        var updateName = new UpdateDeviceNameCommand();
        updateName.execute(newDeviceName, deviceModel, session.user.organisation.id)
            .then(this.onSuccess)
            .catch(this.onError);
        deviceModel.name = newDeviceName;
        if (!settingsDisabled) {
            var command = new UpdateDeviceSettingsCommand();
            command.execute(deviceModel, {
                operatingHoursEnabled: newOperatingHoursEnabledValue,
                gps: gpsEnabled ? newGpsSettingValue : DeviceGpsSetting.Disabled,
                wakeupIntervalSeconds: Math.round(newWakeupIntervalValue)
            }, session.user.organisation.id, intl)
                .then(this.onSuccess)
                .catch(this.onError);
        }
    };
    /**
     *
     */
    UpdateDeviceSettingsOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     */
    UpdateDeviceSettingsOverlay.prototype.onSuccess = function () {
        this.setState({ errors: null, submitting: true });
        var onDeviceUpdate = this.state.onDeviceUpdate;
        if (onDeviceUpdate) {
            onDeviceUpdate();
        }
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     * @param error
     */
    UpdateDeviceSettingsOverlay.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    UpdateDeviceSettingsOverlay.prototype.intervalMultiplier = function (intervalType) {
        switch (intervalType) {
            case "MINUTE":
                return 60;
            case "HOUR":
                return 3600;
            case "DAY":
                return 86400;
        }
    };
    UpdateDeviceSettingsOverlay.defaultProps = {
        className: ''
    };
    return UpdateDeviceSettingsOverlay;
}(React.Component));
UpdateDeviceSettingsOverlay.contextType = ApplicationContext;
export default injectIntl(UpdateDeviceSettingsOverlay);
